import { h } from 'preact';
import Hls from 'hls.js';

/**
 * Autoplaying, muted, looping HLS video for feed/frontpage cards. Extracted
 * from components/gui/listFrontpage.js so that hls.js is only referenced from
 * C (streaming) code — the Dyrejournal build ships without it.
 */
const AutoplayHlsVideo = ({ poster, hlsUrl, maxHeight }) => (
    <div class='video-player-wrapper d-flex flex-column w-100'>
        <video
            autoplay
            muted
            loop
            playsinline
            poster={poster}
            class='w-100'
            style={`object-fit: cover; max-height: ${maxHeight};`}
            ref={el => {
                if (el && !el._hlsAttached) {
                    el._hlsAttached = true;
                    if (Hls.isSupported()) {
                        const hls = new Hls();
                        hls.loadSource(hlsUrl);
                        hls.attachMedia(el);
                    } else if (el.canPlayType('application/vnd.apple.mpegurl')) {
                        el.src = hlsUrl;
                    }
                }
            }}
        />
    </div>
);

export default AutoplayHlsVideo;
